/* eslint-disable jsdoc/no-types */
/* eslint-disable @angular-eslint/component-selector */
import { Component, Input, OnInit } from '@angular/core';
import { EmployeesMessages } from 'src/app/models/empleados';
import { EmployeesService } from 'src/app/services/employees.service';

@Component({
    selector: 'mensaje',
    templateUrl: './mensaje.component.html',
    styleUrls: ['./mensaje.component.scss'],
})
export class MensajeComponent implements OnInit {

    // #region Propiedades públicas
    @Input() mensaje: EmployeesMessages;
    // #endregion

    constructor(
        private employeesService: EmployeesService
    ) { }

    ngOnInit() { }

    // #region Métodos públicos

    /**
     * Comprueba si el mensaje es obligatorio de leer pero aún no ha sido leído.
     *
     * @returns {boolean} True si el mensaje es obligatorio de leer y no ha sido leído, de lo contrario false.
     */
    esObligatorioSinLeer(): boolean {
        return this.mensaje.lecturaObligatoria && !this.mensaje.leido;
    }

    /**
     * Marca el mensaje como leído.
     *
     * @returns {boolean} True si el mensaje es obligatorio de leer y ya ha sido leído, de lo contrario false.
     */
    marcarComoLeido(): void {
        this.employeesService.setMensajeLeido(this.mensaje);
    }

    // #endregion
}
